/** iOS/Android custom scheme — must match native CFBundleURLSchemes. */
export const NATIVE_APP_SCHEME = "com.chiangpl.moneytrack.app";

export const AUTH_VERIFIED_PATH = "/auth/verified";
export const AUTH_RESET_PASSWORD_PATH = "/auth/reset-password";

/** Open the installed MoneyTrack app (Safari → custom scheme). */
export function openNativeApp(path: string = "auth/verified"): void {
  const hostPath = path.replace(/^\//, "");
  window.location.href = `${NATIVE_APP_SCHEME}://${hostPath}`;
}
